import { ARBITRUM, ARBITRUM_TESTNET, AVALANCHE, FTMTEST, MAINNET, OPTEST } from "./chains";

// export const GMX_STATS_API_URL = "http://localhost:3010";
// export const GMX_STATS_API_URL = "https://hj-fantom-gateway.wzjo2o.com";
// export const GMX_STATS_API_URL = "https://gateway.avt.trade";
// export const GMX_STATS_API_URL = "https://gateway.felix-gmx.com";

export const GMX_STATS_DOMAIN = process.env.REACT_APP_DOMAIN;
export const GMX_STATS_API_URL = process.env.REACT_APP_AIP_URL;
export const AVT_STATS_URL = process.env.REACT_APP_STATS_URL;
export const  GMX_STATS_BASE_URL = process.env.NODE_ENV === 'production' ? GMX_STATS_API_URL : process.env.REACT_APP_PROXY_URL_PREFIX;

const BACKEND_URLS = {
  // default: "https://gateway.avt.trade",
  default: GMX_STATS_BASE_URL,

  [MAINNET]: "https://gambit-server-staging.uc.r.appspot.com",
  [ARBITRUM_TESTNET]: "https://gambit-server-devnet.uc.r.appspot.com",
  [ARBITRUM]: "https://gmx-server-mainnet.uw.r.appspot.com",
  [AVALANCHE]: "https://gmx-avax-server.uc.r.appspot.com",
  // [FTMTEST]: "https://hj-fantom-gateway.wzjo2o.com",
  // [OPTEST]: "https://gateway.avt.trade",

  [FTMTEST]: GMX_STATS_BASE_URL,
  [OPTEST]: GMX_STATS_BASE_URL,
  // [OPTEST]: "http://localhost:3010",
  // [FTMTEST]: "https://gateway.felix-gmx.com",
};

export function getServerBaseUrl(chainId: number) {
  if (!chainId) {
    throw new Error("chainId is not provided");
  }

  if (document.location.hostname.includes("deploy-preview")) {
    const fromLocalStorage = localStorage.getItem("SERVER_BASE_URL");
    if (fromLocalStorage) {
      return fromLocalStorage;
    }
  }

  return BACKEND_URLS[chainId] || BACKEND_URLS.default;
}

export function getServerUrl(chainId: number, path: string) {
  return `${getServerBaseUrl(chainId)}${path}`;
}
